var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectInventoryResourceInfo } from "../../selectors/selectInventoryInfo";
import { selectStorageInfo } from "../../selectors/selectStorageInfo";
import { DescriptionProducts } from "./DescriptionProducts";
import { ProductInformation } from "./ProductInformation";
import { ProductStats } from "./ProductStats";
import { TradePanel } from "./TradePanel";
export var _DetailViewProducts = function (_a) {
    var item = _a.item, maxStorage = _a.maxStorage;
    if (item) {
        return (React.createElement("div", { className: "flex flex--guts " + IdStyles.DetailViewWrapper },
            React.createElement("div", { className: "farm-management-detail " + IdStyles.DetailView },
                React.createElement(ProductInformation, { item: item },
                    React.createElement(ProductStats, { item: item, maxStorage: maxStorage, className: "product-information" })),
                React.createElement(DescriptionProducts, { item: item }),
                React.createElement(TradePanel, { item: item, maxStorage: maxStorage }))));
    }
    return React.createElement(React.Fragment, null);
};
var mapState = function (state, ownProps) {
    var item;
    if (ownProps.item !== undefined) {
        var amount = selectInventoryResourceInfo(state, ownProps.item.id).amount || Long.ZERO;
        item = __assign({}, ownProps.item, { amount: amount });
    }
    return {
        item: item,
        maxStorage: selectStorageInfo(state),
    };
};
export var DetailViewProducts = connect(mapState)(_DetailViewProducts);



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/DetailViewProducts.tsx
// module id = 2644
// module chunks = 3